import React, { useEffect } from "react";
import { useCustomer } from "~/hooks/useSession";

declare global {
  interface Window {
    tfcapi?: (action: string) => void;
  }
}

export interface TrueFitWidgetProps {
  /**
   * Id of the product.
   */
  productId: string;
  /**
   * Locale for TrueFit widget.
   */
  locale: string;
  /**
   * Enable TrueFit for the product.
   */
  enableTrueFit: boolean;
}

export function TrueFitWidget({
  productId,
  locale,
  enableTrueFit,
}: TrueFitWidgetProps) {
  // Temporarily enable for Bared staff only.
  const customer = useCustomer();
  const isBaredStaff =
    customer?.email?.includes("@bared.com.au") ||
    customer?.email?.includes("@baredfootwear.com");

  const isEnabled = enableTrueFit ?? false;

  useEffect(() => {
    if (isEnabled) {
      const tfcapi = window?.tfcapi;
      if (tfcapi) {
        tfcapi("calculate");
      }
    }
  }, [productId, customer, enableTrueFit]);

  return isEnabled ? (
    <div
      className="tfc-fitrec-product"
      data-styleid={productId}
      data-locale={locale}
    />
  ) : null;
}
